module.exports = __webpack_public_path__ + "media/4.fa8f1497.mp3";